module.exports = __webpack_public_path__ + "img/baseketball-default.jpg";